// hooks/useSubscription.js
import { useContext } from "react";
import { useAuth } from "../context/AuthProvider";
import { getSubscriptionStatus } from "../utils/tools";

const useSubscription = () => {
  const { user } = useAuth();
  const hasBasicPlan = () => {
    return (
      user &&
      user.subscriptions &&
      getSubscriptionStatus(user.subscriptions) === "basic"
    );
  };

  const hasCreatorPlan = () => {
    return (
      user &&
      user.subscriptions &&
      getSubscriptionStatus(user.subscriptions) === "creator"
    );
  };

  const hasPowerPlan = () => {
    return (
      user &&
      user.subscriptions &&
      getSubscriptionStatus(user.subscriptions) === "power"
    );
  };

  return { hasBasicPlan, hasCreatorPlan, hasPowerPlan };
};

export default useSubscription;
